export default __webpack_public_path__ + "static/media/Mystic's Mask of the Exalted Spirit.1a4bd884.jpg";